import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PublicRoute from './PublicRoute';
import SignInPage from 'SiginIn';
import AppLayout from 'layout/AppLayout';
import Gate from 'Gate';
import PrivateRoute from 'PrivateRoute';
import TaskCongratsPage from 'pages/task/TaskCongratsPage';
import TaskDetailPage from 'pages/task/TaskDetailPage';
import TaskFormPage from 'pages/task/TaskFormPage';
import SummaryPage from 'pages/task/SummaryPage';
import './App.scss';

const App: React.FC = () => {
  return (
    <div style={{ height: "100%", minHeight: "100vh", background: "#2a75da12" }}>
      <Routes>
        <Route path="/" element={
          <Gate />
        } />
        <Route path="intro" element={<PrivateRoute><TaskDetailPage /></PrivateRoute>} />
        <Route path="submission" element={<PrivateRoute><TaskFormPage /></PrivateRoute>} />
        <Route path="congrats" element={<PrivateRoute><TaskCongratsPage /></PrivateRoute>} />
        <Route path="summary" element={<PrivateRoute><SummaryPage /></PrivateRoute>} />

        <Route path="demo" element={<TaskFormPage />} />

        <Route path="mAccess" element={<TaskFormPage />} />
        <Route path="mAccess/summary" element={<SummaryPage />} />
        <Route path="mAccess/congrats" element={<TaskCongratsPage />} />
      </Routes>
    </div>
  );
};

export default App;